<template>
  <section class="column">
    <h1>
      {{
        $store.state.campaign && $store.state.campaign === 'cold-email-marketing'
          ? t('banner_h1_cold_email_marketing')
          : t('banner_h1_early_stage')
      }}
    </h1>

    <h2>
      {{
        $store.state.campaign && $store.state.campaign === 'cold-email-marketing'
          ? t('banner_h2_cold_email_marketing')
          : t('banner_h2_early_stage')
      }}
    </h2>

    <div class="btn__area column">
      <a
        :href="`https://app.arcticreply.com/auth/register?language=${$store.state.language}&campaign=${$store.state.campaign}`"
        target="_blank"
        rel="noopener noreferrer"
        class="register row center"
      >
        {{ t('banner_btn_1') }}
        <i class="fa-solid fa-mountain"></i>
      </a>

      <span class="subtitle">
        {{ t('banner_btn_disclaimer') }}
      </span>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap');
@import '@/assets/media.scss';

section {
  width: 800px;
  max-width: 90%;
  margin: 100px auto 0 auto;
  text-align: center;

  h1 {
    line-height: 60px;
    margin-bottom: 0;
    letter-spacing: -1px;
    font-family: 'Poppins', serif;
    font-weight: 700;
    font-style: normal;
    font-size: 3.5rem;

    @media (max-width: 699px) {
      font-size: 2.75rem;
    }

    @media #{$mobile} {
      font-size: 2.125rem;
      line-height: 38px;
    }
  }

  h2 {
    font-weight: normal;
    line-height: 28px;
    font-size: 1.3rem;
  }

  .btn__area {
    justify-content: center;
    margin: 0 auto;
    width: 400px;
    max-width: 100%;

    @media (max-width: 599px) {
      flex-direction: column;
      align-items: center;
    }

    a {
      text-decoration: none;
      background-color: var(--dark-10);
      color: var(--base);
      margin: 40px 3px 5px 3px;
      padding: 10px 25px;
      border-radius: 50px;
      font-size: 1.25rem;
      cursor: pointer;

      @media (max-width: 599px) {
        font-size: 1.1rem;
      }

      i {
        margin-left: 10px;
      }

      &:hover,
      &:active {
        transform: scale(0.98);
      }

      &.register {
        background-color: var(--highlight);
        color: var(--dak-10);

        @media (max-width: 599px) {
          margin-top: 0;
        }
      }
    }

    .subtitle {
      font-size: 0.8rem;
      color: var(--dark-6);
    }
  }
}
</style>
